import React from 'react';
import Wrapper from './Wrapper.jsx';
import TextArea from './TextArea.jsx';
import MarkdownViewer from './MarkdownViewer.jsx';
const MarkdownEditor = ({
	name,
	value = '', 
	onChange,
}) => {
  


	const onChangeValue = (e) => {
		const newValue = e.target.value;
		onChange({ target: { name, value: newValue } });
	};
	return (
		<Wrapper style={{ marginBottom: '1rem', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
			<div>
				<TextArea
					style={{ width: '100%', height: 'auto' }}
					name={name}
					autogrow={true}
					value={value}
					onChange={onChangeValue}
				/>
			</div>
			<div style={{ padding: '0.5rem', backgroundColor: '#f4f4f4', borderRadius: '0.5rem' }}>
				<MarkdownViewer value={value} /> 
			</div>
		</Wrapper>
	);
};


MarkdownEditor.type = 'MarkdownEditor';

export default MarkdownEditor;
